/**
 * AlmadarPostLearningFromInterruptionsSLAlmadarPostLearningFromInterruptionsSLPage
 *
 * Page component for AlmadarPostLearningFromInterruptionsSLAlmadarPostLearningFromInterruptionsSLPage
 * Path: /sl/blog/learning-from-interruptions
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostLearningFromInterruptionsSLPostPageView as __AlmadarPostLearningFromInterruptionsSLPostPageView } from '@/components/traits/AlmadarPostLearningFromInterruptionsSLPostPageView';
import { AlmadarPostLearningFromInterruptionsSLPostAnalyticsView as __AlmadarPostLearningFromInterruptionsSLPostAnalyticsView } from '@/components/traits/AlmadarPostLearningFromInterruptionsSLPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostLearningFromInterruptionsSLAlmadarPostLearningFromInterruptionsSLPageProps {
  // Add any page-level props here
}

export function AlmadarPostLearningFromInterruptionsSLAlmadarPostLearningFromInterruptionsSLPage(_props: AlmadarPostLearningFromInterruptionsSLAlmadarPostLearningFromInterruptionsSLPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostLearningFromInterruptionsSLPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostLearningFromInterruptionsSLPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostLearningFromInterruptionsSLAlmadarPostLearningFromInterruptionsSLPage;
